export enum TypeFormEnum {
  BUDGET_TASK = 'BUDGET_TASK',
  RATE_PLAN = 'RATE_PLAN',
  CONTRAGENT = 'CONTRAGENT',
  PLANNED_INCOME = 'PLANNED_INCOME',
  DIRECTION = 'DIRECTION',
  DIRECTION_GROUP = 'DIRECTION_GROUP',
  UNIT = 'UNIT',
  FILIAL = 'FILIAL',
  ROOM = 'ROOM',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  OPERATION_TYPE = 'OPERATION_TYPE',
  OPERATION_TYPE_ERP_1C = 'OPERATION_TYPE_ERP_1C',
  MASTER_MILESTONE = 'MASTER_MILESTONE',
  APPROVAL_SCHEME = 'APPROVAL_SCHEME',
  PAYMENT_TASK = 'PAYMENT_TASK',
  PAYMENT_TEMPLATE = 'PAYMENT_TEMPLATE',
  PAYMENT_STATUS = 'PAYMENT_STATUS',
  DATABASE_1C = 'DATABASE_1C',
  COMPANY = 'COMPANY',
  COMPANY_GROUP = 'COMPANY_GROUP',
  CLIENT = 'CLIENT',
  EXTERNAL_USER_CREATE = 'EXTERNAL_USER_CREATE',
  EXTERNAL_USER_EDIT = 'EXTERNAL_USER_EDIT',
  USER_CREATE = 'USER_CREATE',
  USER_EDIT = 'USER_EDIT',
  USER_GROUP = 'USER_GROUP',
  ROLE = 'ROLE',
  WORK_SCHEDULE = 'WORK_SCHEDULE',
  EXTENSION_1C = 'EXTENSION_1C',
  CHANGELOG = 'CHANGELOG',
  DEAL_GROUP = 'DEAL_GROUP',
  DEAL = 'DEAL',
  EXCLUSION = 'EXCLUSION',
  NEWSLETTER = 'NEWSLETTER',
  NEWSLETTER_TEMPLATE = 'NEWSLETTER_TEMPLATE',
  HELPDESK = 'HELPDESK',
  HELPDESK_ACCEPT_TASK = 'HELPDESK_ACCEPT_TASK',
  HELPDESK_TEMPLATE = 'HELPDESK_TEMPLATE',
  HELPDESK_TASK_TYPE = 'HELPDESK_TASK_TYPE',
  HELPDESK_EAV_ENTITY_TYPE = 'HELPDESK_EAV_ENTITY_TYPE',
  PROJECT = 'PROJECT',
  PROJECT_TEMPLATE = 'PROJECT_TEMPLATE',
  BALANCE_CUSTOM_ROW = 'BALANCE_CUSTOM_ROW',
  DOCUMENT = 'DOCUMENT',
  DOCUMENT_TEMPLATE = 'DOCUMENT_TEMPLATE',
  DOCUMENT_REGULATION = 'DOCUMENT_REGULATION',
  CONTRACT = 'CONTRACT',
  DOCUMENT_DISTRIBUTION = 'DOCUMENT_DISTRIBUTION',
  NOMENCLATURE = 'NOMENCLATURE',
  NOMENCLATURE_GROUP = 'NOMENCLATURE_GROUP',
  CONVERTER = 'CONVERTER',
  ACCESS_CARD = 'ACCESS_CARD',
  KKT = 'KKT',
  TYPE_OF_ACTIVITY = 'TYPE_OF_ACTIVITY',
  LK_EU_HELPDESK = 'LK_EU_HELPDESK',
  LK_EU_TRANSIT_TASK = 'LK_EU_TRANSIT_TASK',
  COST_CENTER = 'COST_CENTER',
  TRAFFIC_ADAPTER = 'TRAFFIC_ADAPTER',
  KBK = 'KBK',
  PAYER_STATUS = 'PAYER_STATUS',
  REVENUE_ADMIN = 'REVENUE_ADMIN',
  CURRENCY = 'CURRENCY',
  TASK_SCENARIO = 'TASK_SCENARIO',
  TRANSIT_TASK = 'TRANSIT_TASK',
  RESIDENT_CAR = 'RESIDENT_CAR',
  NET_PING_DEVICE = 'NET_PING_DEVICE',
  HIKVISION_CAMERA = 'HIKVISION_CAMERA'
}
